
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { SessionMenuComponent } from './session-menu.component';
import { VideoShareDialogModule } from '@go-modules/components/dialogs/video-share-dialog/video-share-dialog.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		MatMenuModule,
		VideoShareDialogModule
	],
	declarations: [
		SessionMenuComponent
	],
	exports: [
		SessionMenuComponent
	]
})
export class SessionMenuModule {}
